module.exports = __webpack_public_path__ + "img/holiday_lighting_installation.b6355675.jpg";